// EWM-630 — imperative control over the Zendesk chat launcher's visibility.
//
// The Zendesk messaging Web Widget (loaded by the snippet in `index.tsx`,
// EWM-547) exposes a global command function `window.zE`. Calling
// `zE('messenger', 'hide' | 'show')` toggles the floating launcher (and any
// open messenger) app-wide. The snippet installs `window.zE` as a command
// queue immediately, so calls made before the widget finishes loading are
// queued and applied on load — no readiness race to guard.
//
// Used by `useHideZendeskWidget` to suppress the launcher while the Windcave
// card modal is open, so the bubble stops overlapping the PAY button on the
// mobile bottom sheet. Guarded + no-op when the widget isn't present (SSR,
// widget disabled, ad-blocked) so it can never break a page.

type ZendeskCommand = (api: 'messenger', action: 'show' | 'hide') => void;

interface WindowWithZendesk extends Window {
  zE?: ZendeskCommand;
}

export const setZendeskWidgetVisible = (visible: boolean): void => {
  if (typeof window === 'undefined') return;
  const zE = (window as WindowWithZendesk).zE;
  if (typeof zE !== 'function') return;
  try {
    zE('messenger', visible ? 'show' : 'hide');
  } catch {
    // The widget global exists but rejected the command (unexpected SDK
    // shape) — non-fatal; the modal + payment flow must never break over
    // chrome cosmetics.
  }
};
